import type { TypedChartComponent } from 'react-chartjs-2/dist/types'

export const COLORS = {
    blue: '#051371',
    blue10: '#EDEEF6',
    red: '#EF0808',
}

export const getBorderWidth = (points: number) => 2 - Math.min(0.2 * Math.floor(points / 5), 1)
export const getPointBorderWidth = (points: number) => 4 - Math.min(0.3 * Math.floor(points / 3), 2)
export const getPointRadius = (points: number) => 6 - Math.min(0.3 * Math.floor(points / 3), 3)

export const options: Parameters<TypedChartComponent<'line'>>[0]['options'] = {
    layout: {
        padding: {
            top: 35,
        },
    },
    responsive: true,
    scales: {
        x: {
            border: {
                display: false,
            },
            grid: {
                display: false,
            },
            ticks: {
                padding: 15,
                color: COLORS.blue,
                font: {
                    weight: 300,
                    family: 'Parka',
                    size: 10,
                },
            },
        },
        y: {
            display: false,
        },
    },
    plugins: {
        legend: {
            display: false,
        },
        title: {
            display: false,
        },
        tooltip: {
            backgroundColor: COLORS.red,
            padding: 4,
            caretSize: 0,
            caretPadding: 14,
            yAlign: 'bottom',
            bodyFont: {
                family: 'Parka',
                weight: 700,
            },
            displayColors: false,
            callbacks: {
                title: () => '',
            },
        },
    },
    animation: {
        easing: 'easeInOutBack',
    },
}
